import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loggedInData: null,
    access_token: null,
    firstRouterHasLoaded: false,
    showWelcomeAlert: null,
    trace_ar: [],
    isStandalone: null,
    version: "1.0.1"
  },
  mutations: {
    SET_LOGGED_IN_DATA(state, loggedInData = null) {
      state.loggedInData = loggedInData
    },
    SET_ACCESS_TOKEN(state, access_token = null) {
      state.access_token = access_token
    },
    SET_FIRST_ROUTER_HAS_LOADED(state) {
      state.firstRouterHasLoaded = true
    },
    SET_IS_STANDALONE(state, value) {
      state.isStandalone = value
    },
    PREPEND_TRACE(state, output) {
      state.trace_ar.unshift(output)
    },
    SHOW_WELCOME_ALERT(state, value) {
      state.showWelcomeAlert = value
    }
  },
  getters: {
    version: state => {
      return state.version
    },
    isStandalone: state => {
      return state.isStandalone
    },
    showWelcomeAlert: state => {
      return state.showWelcomeAlert
    },
    getHomeRoute: (state, getters) => {
      if (getters.isLoggedIn) {
        switch (getters.agentType) {
          case 'driver':
            return 'driver-dashboard'
          case 'company':
            return 'company-dashboard'
        }
      }
      return 'home'
    },
    traceOutput: state => {
      return state.trace_ar.length == 0 ? '' : '<ul><li>' + state.trace_ar.join('</li><li>') + '</li></ul>'
    },
    isLoggedIn: state => {
      return !!(state.loggedInData && state.loggedInData.userData)
    },
    access_token: state => {
      return state.access_token
    },
    userName: (state, getters) => {
      if (getters.isLoggedIn) {
        return state.loggedInData.userData.name
      }
      return ''
    },
    agentType: (state, getters) => {
      if (getters.isLoggedIn) {
        return state.loggedInData.agentData.type
      }
      return ''
    },
    agentName: (state, getters) => {
      if (getters.isLoggedIn) {
        return state.loggedInData.agentData.name
      }
      return ''
    },
    agentId: (state, getters) => {
      if (getters.isLoggedIn) {
        return state.loggedInData.agentData.id
      }
      return ''
    },
    isGreen: (state, getters) => {
      if (getters.isLoggedIn) {
        return !!state.loggedInData.agentData.isGreen
      }
      return null
    },
    isDeveloper: (state, getters) => {
      if (getters.isLoggedIn) {
        return !!state.loggedInData.agentData.isDeveloper
      }
      return null
    },
    isLoggedInAs: (state, getters) => {
      if (getters.isLoggedIn) {
        return !!state.loggedInData.isLoggedInAs
      }
      return null
    },
    isAdmin: (state, getters) => {
      if (getters.isLoggedIn) {
        return !!state.loggedInData.userData.isAdmin
      }
      return null
    },
    agentData: (state, getters) => {
      if (getters.isLoggedIn) {
        return state.loggedInData.agentData
      }
      return null
    },
    loggedInData: (state, getters) => {
      if (getters.isLoggedIn) {
        return state.loggedInData
      }
      return null
      /* loggedInData reference:
      {
        userData: {
          id: number,
          name: string,
          email: email
        },
        agentData: {
          type: string,
          [id]: number,
          [name]: string
        },
        agentAccessData: {
          hasCompany: boolean,
          hasDriver: boolean,
          [companyData_ar]: [
            {
              id: number,
              name: string
            }
          ]
        }
      }
      */
    },
    hasMultipleAgentAccess: (state, getters) => {
      if (getters.isLoggedIn) {
        if (state.loggedInData.agentAccessData.hasCompany) {
          //multiple agent access is only possible if has company
          if (state.loggedInData.agentAccessData.hasDriver || state.loggedInData.agentAccessData.companyData_ar.length > 1) {
            //also has driver, OR has multiple companies
            return true
          }
        }
        return false
      }
      return null
    }
  },
  actions: {
    setFirstRouterHasLoaded({ commit }) {
      commit('SET_FIRST_ROUTER_HAS_LOADED', true)
    },
    setIsStandalone({ commit }) {
      const flag = (window.matchMedia('(display-mode: standalone)').matches)
      commit('SET_IS_STANDALONE', flag)
    },
    setAccessToken({ commit }, access_token) {
      commit('SET_ACCESS_TOKEN', access_token)
    },
    closeWelcomeAlert({ commit }) {
      commit('SHOW_WELCOME_ALERT', false)
    },
    onAuth({ commit }, data) {
      commit('SET_LOGGED_IN_DATA', data.loggedInData)
      if (data.access_token) {
        //access_token is not sent when switching accounts e.g
        //store access_token in store
        commit('SET_ACCESS_TOKEN', data.access_token)
        //store access_token in localStorage
        setLocalStorage('access_token', data.access_token)
//        commit('SHOW_WELCOME_ALERT', true)
      }
      switch (data.loggedInData.agentData.type) {
        case 'company':
          //store cmpId in localStorage (in order to be able to login at this cmpId on reload)
          setLocalStorage('cmpId', data.loggedInData.agentData.id)
        break
        case 'driver':
          //delete possible cmpId from localStorage
          deleteLocalStorage('cmpId')
        break
      }
      return
    },
    prependTrace({ commit }, output) {
      commit('PREPEND_TRACE', output)
    },
    logout({ commit }) {
      commit('SET_LOGGED_IN_DATA')
      commit('SET_ACCESS_TOKEN')
      deleteLocalStorage('access_token')
      deleteLocalStorage('cmpId')
    }
  }
})
//local storage functions
function setLocalStorage(key, value) {
  //ensure data as an JSON string
  let data = (typeof value === 'string') ? value : JSON.stringify(value)
  //store value in localStorage so it will be persistent over page reloads
  localStorage.setItem(key, data);
}
function deleteLocalStorage(key) {
  //remove from local storage
  localStorage.removeItem(key)
}
/*
function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
   return false;
  }
  return true;
}
*/
